import React, { FC, useEffect, useMemo } from 'react'
import { List } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useHistory } from 'react-router-dom'

import { ContractAlertDot } from '../Common/Selectors/ContractAlertDot'
import { useTotalUnreadDocCount } from '../../hooks'
import {
  StyledAccordion,
  StyledAccordionDetails,
  StyledAccordionSubBox,
  StyledAccordionSubSummary,
  StyledCompanyName,
  StyledItem,
  StyledListItem,
} from './StyledComponents'

export const CompanySelectAccordionSubgroup: FC<{
  title: string
  details: {
    name: string
    href: string
    haveAlertPoint?: boolean
  }[]
}> = ({ title, details }) => {
  const history = useHistory()
  const { docsCount, refetchDocsCount } = useTotalUnreadDocCount()

  const handleClick = (e: React.ChangeEvent<unknown>) => {
    e.stopPropagation()
  }

  const handleClickItem = (path: string) => {
    history.push(path)
  }

  const hideSummaryDot = useMemo(() => {
    return !details.some((item) => item?.haveAlertPoint) || !docsCount
  }, [details, docsCount])

  useEffect(() => {
    refetchDocsCount().then()
  }, [])

  return (
    <StyledAccordion
      square
      sx={{
        backgroundColor: 'transparent',
        '&.MuiAccordion-root': {
          padding: 0,
        },
      }}
    >
      <StyledAccordionSubSummary expandIcon={<ExpandMoreIcon />} onClick={handleClick}>
        <StyledAccordionSubBox>
          <ContractAlertDot size={8} hidden={hideSummaryDot} />
          <StyledItem>{title}</StyledItem>
        </StyledAccordionSubBox>
      </StyledAccordionSubSummary>

      <StyledAccordionDetails>
        <List>
          {details.map(({ name, href, haveAlertPoint }) => (
            <StyledListItem
              key={name}
              active={history.location.pathname === href}
              onClick={() => handleClickItem(href)}
            >
              <StyledCompanyName>
                <ContractAlertDot size={8} top={3} hidden={!haveAlertPoint || !docsCount} />
                {name}
              </StyledCompanyName>
            </StyledListItem>
          ))}
        </List>
      </StyledAccordionDetails>
    </StyledAccordion>
  )
}
